import { useEffect, useState } from 'react';
import './App.css';
import { useRoutes, Navigate, useNavigate, useLocation } from 'react-router-dom';
import wv_logo from "./images/wv_logo_en.jpg";
import { BatchQRCode, CreateQRCode, Login } from './pages';
import { clearSession, getUsername, getRole, isAuthenticated, saveProfile } from './auth.js';
import apis from './api.js';

function RequireAuth({ children }) {
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const result = await apis.me();
      if (cancelled) return;
      if (result.ok) {
        saveProfile({
          username: result.msg.username,
          role: result.msg.role,
        });
        setStatus('ok');
      } else {
        clearSession();
        setStatus('no');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (status === 'loading') {
    return <div style={{ padding: 24 }}>Loading…</div>;
  }
  if (status === 'no') {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const onLoginPage = location.pathname === "/login";

  let routes = useRoutes([
    { path: '/login', element: <Login title="Login - Faster Payment System" /> },
    {
      path: '/createQR',
      element: (
        <RequireAuth>
          <CreateQRCode title="Create - Faster Payment System - QR Code Generator" />
        </RequireAuth>
      ),
    },
    {
      path: '/createbatch',
      element: (
        <RequireAuth>
          <BatchQRCode title="CreateByBatch - Faster Payment System - QR Code Generator" />
        </RequireAuth>
      ),
    },
    { path: '/', element: <Navigate to="/login" replace /> },
    { path: '*', element: <Navigate to="/login" replace /> },
  ]);

  const logout = async () => {
    await apis.logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="App">
      {!onLoginPage ? (
        <div>
          <nav className="App-nav">
            <img src={wv_logo} alt="World Vision" />
            <a href="/createQR">Create FPS QR Code</a>
            <a href='/createbatch' >Create Batch of FPS QR Code(s)</a>
            {isAuthenticated() ? (
              <span className="App-nav-user">
                {getUsername()}
                {getRole() ? ` (${getRole()})` : ""}
                <button type="button" className="App-logout" onClick={logout}>
                  Log out
                </button>
              </span>
            ) : null}
          </nav>
        </div>
      ) : null}
      <div css="clear:inline-start"></div>
      {routes}
    </div>
  );
}

export default App;
